import Layout from "../../../components/Layout";
import Formulario from "../Formulario";

export default function FormFeedback() {
  return Layout(Formulario, "Feedback Semanal");
}
